/* Tecán chapters: one pinned stage, N chapters. Scroll progress through the
   track picks the active chapter; media crossfades and copy swaps via CSS
   classes. Videos play only while active. Reduced motion: no videos, no
   transitions (CSS), but the chapter switching still works. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }

  function init(root) {
    var track = root.querySelector('.tecan-chapters__track');
    var stage = root.querySelector('.tecan-chapters__stage');
    /* 100svh probe: chapter boundaries must not move when Safari's toolbar collapses (innerHeight/dvh change while scrolling) */
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;top:0;left:0;width:0;height:100svh;visibility:hidden;pointer-events:none;';
    track.appendChild(probe);
    var medias = Array.prototype.slice.call(root.querySelectorAll('.tecan-chapters__media'));
    var copies = Array.prototype.slice.call(root.querySelectorAll('.tecan-chapters__copy'));
    var backdrops = Array.prototype.slice.call(root.querySelectorAll('.tecan-chapters__backdrop'));
    var index = Array.prototype.slice.call(root.querySelectorAll('.tecan-chapters__index li'));
    var cue = root.querySelector('.tecan-chapters__cue');
    var n = medias.length;
    if (!track || !n) return;
    var current = 0;

    function video(i) { return medias[i] && medias[i].querySelector('video'); }
    /* Films after the first ship without a src (data-src) so phones don't download ~25 MB on load; attach on demand */
    var loaded = document.readyState === 'complete';
    var warmQueue = [];
    function attachPosters() {
      medias.forEach(function (m) {
        var img = m.querySelector('img[data-src]');
        if (!img) return;
        if (img.getAttribute('data-srcset')) { img.setAttribute('srcset', img.getAttribute('data-srcset')); img.removeAttribute('data-srcset'); }
        img.setAttribute('src', img.getAttribute('data-src')); img.removeAttribute('data-src');
      });
    }
    function flushWarm() {
      loaded = true;
      attachPosters(); /* the other chapters' posters (small) right after load; their films only on demand */
      var q = warmQueue.splice(0);
      q.forEach(function (v) { warm(v); if (v.dataset.intent === 'play' && !document.hidden && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    }
    /* No film request before the page has loaded: the poster (same first frame) is the LCP image and should not share bandwidth with a 10–16 MB mp4 */
    function afterPaint(fn) { requestAnimationFrame(function () { requestAnimationFrame(function () { setTimeout(fn, 250); }); }); }
    /* Start the films only once the page has loaded AND the hero poster has actually been painted (LCP entry for it),
       so the first film request never competes with the hero image. Fallbacks: 1.5 s after load, 5 s absolute. */
    var loadFired = false, heroPainted = false, flushing = false;
    function maybeFlush() { if (loaded || flushing) return; if (loadFired && heroPainted) { flushing = true; afterPaint(flushWarm); } }
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { if (e.element && medias[0] && medias[0].contains(e.element)) heroPainted = true; });
        maybeFlush();
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (err) { heroPainted = true; }
    window.addEventListener('load', function () { loadFired = true; maybeFlush(); setTimeout(function () { heroPainted = true; maybeFlush(); }, 1500); });
    setTimeout(function () { if (!loaded) flushWarm(); }, 5000);
    function warm(v) {
      if (!v || v.dataset.warm) return;
      if (!loaded) { if (warmQueue.indexOf(v) < 0) warmQueue.push(v); return; }
      var pending = v.querySelectorAll('source[data-src]');
      if (pending.length) {
        Array.prototype.forEach.call(pending, function (src) { src.setAttribute('src', src.getAttribute('data-src')); src.removeAttribute('data-src'); });
        v.load();
      }
      v.dataset.warm = '1';
    }

    function play(i) {
      var v = video(i);
      if (!v || reduce) return;
      warm(v);
      v.preload = 'auto';
      v.loop = true;
      v.muted = true;
      v.dataset.intent = 'play';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function pause(i) {
      var v = video(i);
      if (!v) return;
      v.dataset.intent = 'pause';
      if (!v.paused) v.pause();
    }

    /* Belt and braces: if a loop stalls (buffer hiccup, loop boundary,
       browser throttling) while its chapter is active, restart it. */
    medias.forEach(function (m) {
      var v = m.querySelector('video');
      if (!v) return;
      v.addEventListener('ended', function () { if (v.dataset.intent === 'play') { v.currentTime = 0; v.play().catch(function () {}); } });
      v.addEventListener('pause', function () {
        if (v.dataset.intent !== 'play' || document.hidden) return;
        setTimeout(function () { if (v.dataset.intent === 'play' && v.paused && !document.hidden) v.play().catch(function () {}); }, 250);
      });
      v.addEventListener('stalled', function () { if (v.dataset.intent === 'play') v.load(); });
    });
    setInterval(function () {
      var v = video(current);
      if (v && v.dataset.intent === 'play' && v.paused && !document.hidden && !reduce) v.play().catch(function () {});
    }, 1500);

    function setActive(i, force) {
      if (i === current && !force) return;
      var prev = current;
      current = i;
      medias.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      copies.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      backdrops.forEach(function (b) { b.classList.toggle('is-active', parseInt(b.getAttribute('data-chapter'), 10) === i); });
      index.forEach(function (li, k) { li.classList.toggle('is-active', k === i); });
      if (cue) cue.classList.toggle('is-hidden', i > 0);
      root.classList.toggle('is-intro', !!(copies[i] && copies[i].classList.contains('tecan-chapters__copy--intro'))); /* phones: intro film full-bleed, product films above the copy */
      play(i);
      /* the next chapter's film is warmed halfway through this chapter (see update); stop the rest */
      if (prev !== i) pause(prev);
      medias.forEach(function (m, k) { if (k !== i && k !== prev) pause(k); });
    }

    var ticking = false;
    function update() {
      ticking = false;
      var r = track.getBoundingClientRect();
      var vh = window.innerHeight;
      var svh = (parseFloat(window.getComputedStyle(probe).height) || 0) || vh; /* stable viewport unit, unlike innerHeight on iOS */
      var top0 = (stage && parseFloat(window.getComputedStyle(stage).top)) || 0; /* stage pins under the sticky header on phones */
      var sh = svh - top0; /* design height of the stage (its live height may be dvh-based) */
      var tail = Math.max(0, (parseFloat(track.getAttribute('data-tail')) || 0) / 100 * svh - top0); /* overlap of the next section (cover effect) */
      var total = r.height - sh - tail;
      if (total <= 0) { setActive(0); return; }
      var progress = clamp((top0 - r.top) / total, 0, 0.9999);
      var pos = progress * n;
      setActive(Math.floor(pos));
      /* warm the next chapter's film once the reader is halfway through this one (never on page load) */
      if (pos - Math.floor(pos) > 0.5) { var next = video(Math.floor(pos) + 1); if (next) { warm(next); next.preload = 'auto'; } }
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setActive(0, true);
    update();

    /* Browsers pause autoplay video in a hidden tab; resume the active loop on return */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') play(current);
    });

    /* Pause everything when the stage leaves the viewport entirely */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play(current);
          else medias.forEach(function (_, k) { pause(k); });
        });
      }, { threshold: 0 }).observe(track);
    }
  }

  function boot() {
    document.querySelectorAll('[data-tecan-chapters]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
